var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showNavMenu)?_c('NavMenu',{attrs:{"loginName":_vm.loginName}}):_vm._e(),_c('router-view',{on:{"login-name":_vm.handleLoginName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }